import { FETCH_PRODUCT_UNIT_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const productUnitListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_UNIT_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default productUnitListReducer;
